'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('peer-id'),
    createFromPrivKey = _require.createFromPrivKey;

var errcode = require('err-code');

var debug = require('debug');

var log = debug('ipfs:ipns');
log.error = debug('ipfs:ipns:error');

var IpnsPublisher = require('./publisher');

var IpnsRepublisher = require('./republisher');

var IpnsResolver = require('./resolver');

var _require2 = require('../utils'),
    normalizePath = _require2.normalizePath;

var TLRU = require('../../utils/tlru');

var defaultRecordTtl = 60 * 1000;

var IPNS = /*#__PURE__*/function () {
  function IPNS(routing, datastore, peerInfo, keychain, options) {
    _classCallCheck(this, IPNS);

    this.publisher = new IpnsPublisher(routing, datastore);
    this.republisher = new IpnsRepublisher(this.publisher, datastore, peerInfo, keychain, options);
    this.resolver = new IpnsResolver(routing);
    this.cache = new TLRU(1000);
    this.routing = routing;
  } // Publish


  _createClass(IPNS, [{
    key: "publish",
    value: function () {
      var _publish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(privKey, value) {
        var lifetime,
            peerId,
            id,
            ttEol,
            ttl,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                lifetime = _args.length > 2 && _args[2] !== undefined ? _args[2] : IpnsPublisher.defaultRecordLifetime;
                _context.prev = 1;
                value = normalizePath(value);
                _context.next = 5;
                return createFromPrivKey(privKey.bytes);

              case 5:
                peerId = _context.sent;
                _context.next = 8;
                return this.publisher.publishWithEOL(privKey, value, lifetime);

              case 8:
                log("IPNS value ".concat(value, " was published correctly")); // // Add to cache

                id = peerId.toB58String();
                ttEol = parseFloat(lifetime);
                ttl = ttEol < defaultRecordTtl ? ttEol : defaultRecordTtl;
                this.cache.set(id, value, ttl);
                log("IPNS value ".concat(value, " was cached correctly"));
                return _context.abrupt("return", {
                  name: id,
                  value: value
                });

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](1);
                log.error(_context.t0);
                throw _context.t0;

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 17]]);
      }));

      function publish(_x, _x2) {
        return _publish.apply(this, arguments);
      }

      return publish;
    }() // Resolve

  }, {
    key: "resolve",
    value: function () {
      var _resolve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name, options) {
        var id, result, _result;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(typeof name !== 'string')) {
                  _context2.next = 2;
                  break;
                }

                throw errcode(new Error('name received is not valid'), 'ERR_INVALID_NAME');

              case 2:
                options = options || {}; // If recursive, we should not try to get the cached value

                if (!(!options.nocache && !options.recursive)) {
                  _context2.next = 8;
                  break;
                }

                // Try to get the record from cache
                id = name.split('/')[2];
                result = this.cache.get(id);

                if (!result) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return", result);

              case 8:
                _context2.prev = 8;
                _context2.next = 11;
                return this.resolver.resolve(name, options);

              case 11:
                _result = _context2.sent;
                log("IPNS record from ".concat(name, " was resolved correctly"));
                return _context2.abrupt("return", _result);

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](8);
                log.error(_context2.t0);
                throw _context2.t0;

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 16]]);
      }));

      function resolve(_x3, _x4) {
        return _resolve.apply(this, arguments);
      }

      return resolve;
    }() // Initialize keyspace
    // sets the ipns record for the given key to point to an empty directory

  }, {
    key: "initializeKeyspace",
    value: function () {
      var _initializeKeyspace = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(privKey, value) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.publish(privKey, value, IpnsPublisher.defaultRecordLifetime));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function initializeKeyspace(_x5, _x6) {
        return _initializeKeyspace.apply(this, arguments);
      }

      return initializeKeyspace;
    }()
  }]);

  return IPNS;
}();

module.exports = IPNS;